import { render } from "./Departments.vue?vue&type=template&id=ab6b367e"
import script from "./Departments.vue?vue&type=script&lang=js"
export * from "./Departments.vue?vue&type=script&lang=js"

import "./Departments.vue?vue&type=style&index=0&id=ab6b367e&lang=css"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__